<template>
  <div class="bg-ricoma-gray-200" :class="[classes.container]">
    <VFormSelect
      :initialSelectedOption="language.title"
      :options="langOptions"
      :resetStyles="true"
      @onSelect="handleSetLanguage"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import VFormSelect from '@/components/base/VFormSelect';

export default {
  name: 'LanguageSelect',
  components: { VFormSelect },
  props: {
    classes: {
      type: [String, Object],
      required: false,
      default: () => ({}),
    },
    vuexModule: {
      type: String,
      required: false,
      default: 'customer',
    },
    initialLangCode: {
      type: String,
      required: false,
      default: 'en',
    },
  },
  computed: mapState({
    languages: state => state.languages,
    language: state => state.language,
    langOptions() {
      return this.languages.map(l => l.title);
    },
  }),
  methods: {
    handleSetLanguage(langTitle) {
      const language = this.languages.find(l => l.title === langTitle);
      if (language) {
        this.$store.commit(`setLanguage`, language);
        this.$emit('set', language);
      }
    },
  },
  async mounted() {
    const languages = await this.$store.dispatch(`getLanguages`);
    const language = languages.find(l => l.code === this.initialLangCode);
    this.$store.commit(`setLanguage`, language);
  },
};
</script>
